<a cll-icon-button
   colour="variant"
   [appHelpArticle]="article"
   cllTooltip="Click for more information">
    <cll-icon>{{ icon ?? 'help_outline' }}</cll-icon>
</a>
